<template>
  <v-card class="pl-4 pr-2 py-2 my-2" elevation="0">
    <v-skeleton-loader class="mb-2" type="text" max-width="100" />
    <v-skeleton-loader class="d-flex" type="text" max-width="75" />
  </v-card>
</template>

<script>
export default {
  name: 'UserItemSkeleton',
}
</script>
